import { useState } from "react";
import { useTranslation } from "react-i18next";
import { upsertValueLibrary } from "redux/index";
import { TitleInput } from "shared/cx-components/cx-components.style";
import { GenericButton } from "shared/ui-basics/index";
import styled from "styled-components/macro";
import { createDefaultCustomLibraryItem, encode } from "utils/helpers";

interface CustomLibraryAddItemProps {
	libraryId: string;
	isCreate: boolean;
}

export const CustomLibraryAddItem: React.FC<CustomLibraryAddItemProps> = ({ libraryId, isCreate }) => {
	const { t } = useTranslation();

	const [name, setName] = useState<string>("");
	const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(true);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		setName(value);
		setIsButtonDisabled(value.trim() === "");
	};

	const handleAdd = () => {
		setIsButtonDisabled(true);
		const newItem = createDefaultCustomLibraryItem("#FFFFFF");
		newItem.name = encode(name.truncate(100,true));

		upsertValueLibrary({
			libraryId,
			libraryValue: newItem,
			onSuccess: () => {
				setIsButtonDisabled(false);
				setName("");
			},
		});
	};

	return (
		<Container>
			<TitleInput
				value={name}
				title={name}
				color="#262626"
				fontSize="14px"
				noborder={"true"}
				fontWeight={600}
				className="ps-0"
				name="name"
				placeholder={t("NEW_ITEM")}
				onChange={handleChange}
				autoFocus={!isCreate}
				disabled={false}
			/>
			<GenericButton variant="dark" icon="PLUS" iconClassName="me-1" disabled={isButtonDisabled} onClick={handleAdd}>
				{t("ASPX_108")}
			</GenericButton>
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: 72px;
	padding: 16px;
	border-radius: 4px;
	border: 1px solid #333;
	margin-top: 24px;
`;
